import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get('https://app.hayahost.net/api/reports/stats', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setStats(response.data);
    } catch (err) {
      console.error(err);
    }
  };

  const logout = () => {
    localStorage.clear();
    window.location.href = '/login';
  };

  return (
    <div style={styles.container}>
      {/* الشريط العلوي */}
      <div style={styles.navbar}>
        <h1 style={styles.navTitle}>🏦 نظام الحوالات والصيرفة</h1>
        <div style={styles.navRight}>
          <span style={styles.navUser}>👤 {user.name}</span>
          <button style={styles.logoutBtn} onClick={logout}>خروج</button>
        </div>
      </div>

      {/* القائمة الجانبية */}
      <div style={styles.layout}>
        <div style={styles.sidebar}>
          <a href="/" style={styles.sideItem}>🏠 الرئيسية</a>
          <a href="/customers" style={styles.sideItem}>👥 العملاء</a>
          <a href="/transfers" style={styles.sideItem}>💸 الحوالات</a>
          <a href="/exchange" style={styles.sideItem}>💱 الصرافة</a>
          <a href="/debts" style={styles.sideItem}>📋 المديونيات</a>
          <a href="/treasury" style={styles.sideItem}>🏛️ القاصة</a>
          <a href="/accounts" style={styles.sideItem}>📒 حسابات العملاء</a>
          <a href="/clients" style={styles.sideItem}>🔐 إدارة الفروع</a>
          <a href="/reports" style={styles.sideItem}>📊 التقارير</a>
        </div>

        {/* المحتوى */}
        <div style={styles.content}>
          <h2 style={styles.pageTitle}>لوحة التحكم</h2>

          {stats && (
            <div style={styles.statsGrid}>
              <div style={{...styles.statCard, background: 'linear-gradient(135deg, #1a237e, #0d47a1)'}}>
                <div style={styles.statIcon}>👥</div>
                <div style={styles.statNumber}>{stats.customers}</div>
                <div style={styles.statLabel}>إجمالي العملاء</div>
              </div>

              <div style={{...styles.statCard, background: 'linear-gradient(135deg, #1b5e20, #2e7d32)'}}>
                <div style={styles.statIcon}>💸</div>
                <div style={styles.statNumber}>{stats.transfers.count}</div>
                <div style={styles.statLabel}>إجمالي الحوالات</div>
              </div>

              <div style={{...styles.statCard, background: 'linear-gradient(135deg, #e65100, #f57c00)'}}>
                <div style={styles.statIcon}>💱</div>
                <div style={styles.statNumber}>{stats.exchanges.count}</div>
                <div style={styles.statLabel}>عمليات الصرف</div>
              </div>

              <div style={{...styles.statCard, background: 'linear-gradient(135deg, #880e4f, #c2185b)'}}>
                <div style={styles.statIcon}>📋</div>
                <div style={styles.statNumber}>{stats.pending_debts.count}</div>
                <div style={styles.statLabel}>الديون المعلقة</div>
              </div>
            </div>
          )}

          {/* القاصة */}
          {stats && stats.treasury.length > 0 && (
            <div style={styles.treasuryCard}>
              <h3 style={styles.sectionTitle}>🏛️ القاصة</h3>
              <div style={styles.treasuryGrid}>
                {stats.treasury.map((t, i) => (
                  <div key={i} style={styles.treasuryItem}>
                    <span style={styles.currency}>{t.currency_code}</span>
                    <span style={styles.balance}>{parseFloat(t.balance).toLocaleString()}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', background: '#f5f5f5' },
  navbar: {
    background: 'linear-gradient(135deg, #1a237e, #0d47a1)',
    padding: '15px 30px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  navTitle: { color: 'white', fontSize: '20px' },
  navRight: { display: 'flex', alignItems: 'center', gap: '15px' },
  navUser: { color: 'white' },
  logoutBtn: {
    background: 'rgba(255,255,255,0.2)',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  layout: { display: 'flex' },
  sidebar: {
    width: '200px',
    background: 'white',
    minHeight: 'calc(100vh - 60px)',
    padding: '20px 0',
    boxShadow: '2px 0 5px rgba(0,0,0,0.1)',
  },
  sideItem: {
    display: 'block',
    padding: '12px 20px',
    color: '#333',
    textDecoration: 'none',
    fontSize: '14px',
    borderBottom: '1px solid #f0f0f0',
  },
  content: { flex: 1, padding: '30px' },
  pageTitle: { marginBottom: '25px', color: '#1a237e', fontSize: '24px' },
  statsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: '20px',
    marginBottom: '30px',
  },
  statCard: {
    borderRadius: '12px',
    padding: '25px',
    color: 'white',
    textAlign: 'center',
  },
  statIcon: { fontSize: '30px', marginBottom: '10px' },
  statNumber: { fontSize: '32px', fontWeight: 'bold', marginBottom: '5px' },
  statLabel: { fontSize: '14px', opacity: 0.9 },
  treasuryCard: {
    background: 'white',
    borderRadius: '12px',
    padding: '25px',
    boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
  },
  sectionTitle: { marginBottom: '15px', color: '#1a237e' },
  treasuryGrid: { display: 'flex', gap: '20px' },
  treasuryItem: {
    background: '#f5f5f5',
    borderRadius: '8px',
    padding: '15px 25px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '5px',
  },
  currency: { fontWeight: 'bold', color: '#1a237e', fontSize: '18px' },
  balance: { fontSize: '24px', fontWeight: 'bold', color: '#333' },
};

export default Dashboard;